module.exports = __webpack_public_path__ + "static/media/video-banner.e83f3fc5.png";